const DEFAULT_CONFIG = {

	FONT_SIZE: 'default',
	//标题
	APP_NAME: process.env.VUE_APP_TITLE,

	//版本号
	APP_VER: "1.6.9",

	//接口地址
	API_URL: process.env.NODE_ENV === 'development' && process.env.VUE_APP_PROXY === 'true' ? "/zhyApi" : process.env.VUE_APP_API_BASEURL,
	//请求超时
	TIMEOUT: 10000,
	/**
	 * 接口成功返回状态码
	 */
	RESULT_CODE: 200,

	//TokenName
	TOKEN_NAME: "Authorization",

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "Bearer ",

	//追加其他头
	HEADERS: {},

	//请求是否开启缓存
	REQUEST_CACHE: false,

	//布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	LAYOUT: 'default',


	//语言
	LANG: 'zh-cn',

	//主题颜色
	COLOR: '',

}


export default DEFAULT_CONFIG
